import React from 'react';
import { Grid, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AutoCompleteSelectUI, DebouncedInputUI, FormLabelUI } from '../Interface';
import useSaveView from '../../hooks/useSaveView';
import useUsers from '../../context/UsersContext';
import useParam from '../../context/ParamContext';

const TodoFilters = ({
  formValState,
  autoCompleteOptions,
  prioValue,
  handleOpenAddTaskDialog,
  showAddButton = false,
}) => {
  const { formVal, setFormVal } = formValState;
  const { user } = useUsers();
  const { params } = useParam();
  const saveView = useSaveView(user);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <DebouncedInputUI
          label={<FormLabelUI text="Feladatnév" />}
          debounceMs={800}
          setQuickFilterSearchValue={(newValue) => {
            setFormVal((prevState) => ({
              ...prevState,
              simpleTaskName: newValue,
            }));
          }}
          quickFilterSearchValue={formVal.simpleTaskName}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Státusz" />}
          onChange={(_event, newVal, _reason) => {
            setFormVal((prev) => ({
              ...prev,
              statusId: newVal,
            }));
            saveView('myTodoFilter', { status: newVal });
          }}
          selectedValue={formVal.statusId}
          freeSolo
          isOptionEqualToValue={(option, value) => option.value === value.value}
          multiple
          dataset={autoCompleteOptions.status}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Prioritás" />}
          onChange={(_e, newVal, reason) => {
            if (reason === 'clear') {
              setFormVal((prev) => ({
                ...prev,
                priorId: '',
              }));
              saveView('myTodoFilter', { priority: '' });
            } else {
              setFormVal((prev) => ({
                ...prev,
                priorId: newVal?.value,
              }));
              saveView('myTodoFilter', { priority: newVal });
            }
          }}
          value={prioValue}
          dataset={autoCompleteOptions.priority}
        />
      </Grid>
      {params.SIMPLETASK_COMPANY_LOCATION_FIELD === 'Y' && (
        <Grid item xs={12} md={2}>
          <AutoCompleteSelectUI
            label={<FormLabelUI text="Telephely" />}
            onChange={(_e, newVal, reason) => {
              if (reason === 'clear') {
                setFormVal((prev) => ({
                  ...prev,
                  companyLocationId: '',
                }));
              } else {
                setFormVal((prev) => ({
                  ...prev,
                  companyLocationId: newVal?.value,
                }));
              }
            }}
            selectedValue={formVal.companyLocationId}
            dataset={autoCompleteOptions.companyLocation}
          />
        </Grid>
      )}
      {showAddButton && (
        <Grid item xs={12} md={1}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: '#0fbd1d',
              '&:hover': {
                backgroundColor: '#0ca718',
              },
            }}
            onClick={handleOpenAddTaskDialog}
          >
            Feladat
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default TodoFilters;
